/**
 * @fileoverview Component Price Style
 * @version 1.0
 * @author Carlos Emilio Blanco Lopez
 * @date 14/02/2023
 * @copyright 2023 Industrias RESSER S.A de C.V
 */

import { makeStyles } from "@mui/styles";
import { Fonts, Colors } from "../../utils/constants";

const styles = makeStyles((theme?: any) => ({
    Content: { 
        width: '80%', 
    },
    MobilContent: { 
        marginTop: 20,
        width: '90%', 
        border: "2px solid #FFC72C",
        backgroundColor: "rgba(50, 62, 72, 0.9)",
        height: 'fit-content',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        borderRadius: 10,
        paddingTop: "7.5%",
        paddingBottom: "7.5%",

    },
    Container: {
        border: "2px solid #FFC72C",
        backgroundColor: "rgba(50, 62, 72, 0.9)",
        height: 'fit-content',
        width: '85%',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        borderRadius: 10,
        paddingTop: 10,
    },
    ContainerDesglose: {
        border: "2px solid #FFC72C",
        backgroundColor: "rgba(50, 62, 72, 0.9)",
        height: '100%',
        width: '85%',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        borderRadius: 10,
        [theme.breakpoints.down('xl')]: {
            height: "fit-content",
        },
    },
    txtTitleQuote: {
        fontSize: 16,
        fontFamily: Fonts.sspBold,
        color: Colors.yellow,
        marginBottom: 10,
        wordBreak: 'break-word',
        [theme.breakpoints.down('lg')]: {
            fontSize: "25px"
        },
    },
    txtTitlePriceMobil:{
        fontSize: 10,
        fontFamily: Fonts.sspBold,
        color: "white",
        wordBreak: 'break-word',
    },
    txtSubtitlePrice: {
        fontSize: 20,
        fontFamily: Fonts.sspMedium,
        marginBottom: 0,
        color: "white"
    },
    txtCostoPrice: {
        fontSize: 35,
        fontFamily: Fonts.sspBold,
        color: Colors.yellow,
        marginBottom: 0,
        wordBreak: 'break-word',
        [theme.breakpoints.down('lg')]: {
            fontSize: "2.5em"
        },
    },
    txtIvaPrice: {
        fontSize: 12,
        fontFamily: Fonts.sspMedium,
        marginBottom: 0,
        color: "white"
    },
    txtAdicional: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 20,
        marginTop: 35,
        fontSize: 15,
        color: "white",
        textAlign: 'left',
        [theme.breakpoints.down('lg')]: {
            fontSize: "1em",
            flexDirection: "column",
            marginTop: 10,
            marginBottom: 10,
            height: 50
        },
    },
    txtMontoFinanciado: {
        fontSize: 20,
        fontFamily: Fonts.sspMedium,
        height: 'fit-content',
    },
    txtMontoFinanciadoPrice: {
        fontSize: 24,
        fontFamily: Fonts.sspBold,
        height: 'fit-content',
        color: Colors.yellow,
        wordBreak: 'break-word',
    },
    txtAdicionalPrice: {
        color: Colors.yellow,
        fontFamily: Fonts.sspBold,
    }
}));

export default styles;